import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChartPie, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { COLORS } from '../../constants/theme';

const Section = styled.section`
  padding: 6rem 2rem;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  text-align: center;
  margin-bottom: 3rem;
  color: ${COLORS.pink};
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Card = styled(motion.div)`
  background: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid ${COLORS.whiteSubtle};
  transition: transform 0.3s;
  &:hover { transform: translateY(-5px); }
  h3 {
    color: ${COLORS.pink};
    margin-bottom: 1rem;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  p {
    color: ${COLORS.whiteTransparent};
    line-height: 1.6;
  }
`;

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true } };

function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    { icon: faSearch, titleKey: 'landing.feature1Title', descKey: 'landing.feature1Desc', delay: 0 },
    { icon: faChartPie, titleKey: 'landing.feature2Title', descKey: 'landing.feature2Desc', delay: 0.2 },
    { icon: faChartLine, titleKey: 'landing.feature3Title', descKey: 'landing.feature3Desc', delay: 0.4 }
  ];

  return (
    <Section id="features">
      <Title>{t('landing.featuresTitle')}</Title>
      <Grid>
        {features.map((feature, index) => (
          <Card key={index} {...fadeUp} transition={{ duration: 0.5, delay: feature.delay }}>
            <h3><FontAwesomeIcon icon={feature.icon} /> {t(feature.titleKey)}</h3>
            <p>{t(feature.descKey)}</p>
          </Card>
        ))}
      </Grid>
    </Section>
  );
}

export default FeaturesSection;
